module.exports = __webpack_public_path__ + "img/hokou-ai-3.07c897b4.svg";